class GraphAxisIntervalDisplayOptions {
    constructor(visible, interval, color, offset, lines, linesColor, linesThickness, fontSize, font) {
        this.visible = typeof visible === 'boolean' ? visible : true;
        this.interval = interval || 1;
        this.color = color || "black";
        this.offset = offset || 7;
        this.lines = typeof lines === 'boolean' ? lines : false;
        this.linesColor = linesColor || "black";
        this.linesThickness = linesThickness || 1;
        this.fontSize = fontSize || "20px";
        this.font = font || "Arial";
    }
}
export default GraphAxisIntervalDisplayOptions;
